import {observable} from 'mobx';
import {persist} from 'mobx-persist';
import {ICustomFont} from '../../interface/custom-font.interface';

export class CustomFontModel implements ICustomFont {
  @persist @observable fontUrl: string;
  @persist @observable fontName: string;
  @persist @observable fontFallback: string;
  @persist id: string;
}